module.exports = __webpack_public_path__ + "static/media/overdue3.4b2886d7.svg";